import React from 'react';
import ServiceLayout from '../layouts/ServiceLayout';
import { Box, Typography, Grid, Paper } from '@mui/material';

const HomeCareServices = () => {
  const serviceData = {
    title: "Home Care Services",
    image: "/homecare.png",
    description: "Our home care physiotherapy service brings professional care directly to your doorstep. We provide comprehensive treatment in the comfort of your home, making rehabilitation convenient and accessible.",
    benefits: [
      "Convenient treatment in familiar surroundings",
      "Personalized care plans",
      "No travel required",
      "Family involvement in rehabilitation",
      "Environmental assessment and modification",
      "Flexible scheduling options"
    ],
    approach: [
      "Initial home assessment",
      "Customized treatment planning",
      "Regular progress monitoring",
      "Family education and training",
      "Home safety recommendations",
      "Ongoing support and guidance"
    ],
    additionalContent: (
      <Box sx={{ mt: 4 }}>
        <Typography variant="h4" gutterBottom>
          Our Services Include
        </Typography>
        <Grid container spacing={3}>
          {[
            {
              title: "Post-Hospital Care",
              description: "Specialized rehabilitation for patients recovering from hospital stays or surgeries."
            },
            {
              title: "Chronic Condition Management",
              description: "Ongoing care and support for patients with long-term health conditions."
            },
            {
              title: "Elderly Care",
              description: "Tailored programs to help seniors maintain independence and mobility at home."
            }
          ].map((service, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Paper
                elevation={0}
                sx={{
                  p: 3,
                  height: '100%',
                  borderRadius: 2,
                  border: '1px solid',
                  borderColor: 'divider',
                  transition: 'transform 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-5px)',
                    boxShadow: '0 8px 24px rgba(0,150,136,0.15)'
                  }
                }}
              >
                <Typography variant="h6" gutterBottom color="primary">
                  {service.title}
                </Typography>
                <Typography variant="body2">
                  {service.description}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Box>
    )
  };

  return <ServiceLayout {...serviceData} />;
};

export default HomeCareServices; 